// start_param (t.me/<бот>?startapp=<параметр>) → начальный маршрут. Telegram допускает [A-Za-z0-9_-], ≤ 64.
// Неизвестный параметр → вкладка по умолчанию (null).
const ROUTES: Record<string, string> = { match: '/match/', league: '/league/', team: '/team/', player: '/player/', news: '/news/' };

// Разделы (кнопки клавиатуры бота, команды): tab_<ключ вкладки config> → /tab/<ключ>; live → «Матчи» с фильтром LIVE;
// game → экран игры (кнопка «Итог дня» в личке бота). Мини-игры (bat / chase / bowl) сняты 12.10 (слово владельца) — их ссылки
// теперь неизвестный параметр → вкладка по умолчанию.
/** Рекламная метка едет в том же параметре после двойного подчёркивания: «game__fb-launch1-v2» → куда вести «game»,
 *  метка «fb-launch1-v2» (её разбирает аналитика). Без «__» метки нет. Назначение может быть пустым («__tg-oct»). */
export function splitStartParam(param: string | undefined): { dest: string | undefined; label: string | null } {
  if (!param) return { dest: undefined, label: null };
  const i = param.indexOf('__');
  return i < 0 ? { dest: param, label: null } : { dest: param.slice(0, i) || undefined, label: param.slice(i + 2) || null };
}

export function routeFromStartParam(raw: string | undefined): string | null {
  const param = splitStartParam(raw).dest;
  if (param === 'live') return '/tab/matches?live=1';
  if (param === 'game') return '/game';
  // Кнопки игровых сообщений бота (HQ-190): world_team → папка «Команда», world_login → календарь входа; незнакомый
  // раздел мира → мир. Ключи папок и вкладок — серверные (world_nav.py corner_buttons), вкладка мира по умолчанию — player.
  if (param === 'world_team') return '/world/player/hub?hub=heroes&tab=team';
  if (param === 'world_login') return '/world/player/hub?hub=modes&tab=login';
  if (param === 'world' || param?.startsWith('world_')) return '/world';
  // вторая кнопка под игровым сообщением — «Настройки»: экран уведомлений (AC-9)
  if (param === 'settings_push') return '/settings/push';
  if (param === 'dev_ads' && import.meta.env.DEV) return '/dev/ads';
  // «Прогноз» под тредом матча в группе бота: экран матча сразу на игре (слово бэкенда 12.10, matchgame_<id>)
  const game = /^matchgame_([1-9]\d{0,11})$/.exec(param ?? '');
  if (game) return `/match/${game[1]!}?focus=game`;
  // приглашение друга (§2.18 «Друзья»): ref_<код> — в мир; сам код шлёт session/referral.ts
  if (/^ref_[A-Za-z0-9]{4,32}$/.test(param ?? '')) return '/world';
  const tab = /^tab_([a-z_]{1,32})$/.exec(param ?? '');
  if (tab) return `/tab/${tab[1]}`;
  // лига друзей (§2.15): league_<КОД> — код из букв и цифр; league_<число> — по-прежнему турнир
  const invite = /^league_([A-Za-z0-9]{4,32})$/.exec(param ?? '');
  if (invite && !/^\d+$/.test(invite[1]!)) return `/game/join/${invite[1]!.toUpperCase()}`;
  // id сущности без нуля и ведущих нулей (HQ-1555): match_0 / team_007 → вкладка по умолчанию, а не 404 без выхода
  const m = /^([a-z]+)_([1-9]\d{0,11})$/.exec(param ?? '');
  if (!m) return null;
  const prefix = ROUTES[m[1]!];
  return prefix ? `${prefix}${m[2]}` : null;
}
